export default __webpack_public_path__ + "media/big-goose-party.481630cf.png";